
<template>
  <div class="email-template-triggers">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('notification.manage_email_triggers') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createItem">
                  <i class="fa fa-plus"></i>&nbsp; {{$t('menu-attribute.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col xl="6">
                  <div class="pull-left mr-2">
                    <b-input-group v-bind:prepend="$t('email_template_triggers.gms_service_label')">
                      <b-form-select v-model="filter.gms_service_id" v-bind:value="filter.gms_service_id"
                                     :options="gms_services_id" v-bind:placeholder="$t('email_template_triggers.gms_service_select_service_default_option')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted"
                      v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                      v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('email_template_triggers.datatable.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('email_template_triggers.datatable.'+item.name)}}</span>
                    </th>
                    <th scope="col" style="width: 160px;">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null"
                      v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="100">
                      <span style="display:inline-block; padding: 4px;">
                        <b-button size="sm" variant="warning" v-on:click="previewItem(item)">
                          <i class="fa fa-eye"></i> {{$t('common.preview')}}
                        </b-button>
                      </span>
                      <span style="display:inline-block; padding: 4px;">
                        <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                          <i class="fa fa-edit"></i> {{$t('common.edit')}}
                        </b-button>
                      </span>
                      <span style="display:inline-block; padding: 4px;">
                        <b-button size="sm" variant="danger" v-on:click="deleteItem(item.uuid, item.trigger_id)">
                          <i class="fa fa-close"></i> {{$t('common.delete')}}
                        </b-button>
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                  v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal class="modal-json-editor" ref="jsonEditorModal"
             v-bind:title="$t('email_template_triggers.preview.please_specify_json_content')" size="lg" body-class="padding-none"
             :hide-header="false"
             :hide-footer="false"
             :ok-title="$t('common.preview')"
             :ok-disabled="!canPreviewItem()"
             ok-only @ok="executePreviewItem(this)" >
        <div>
          <p><strong>{{ $t('email_template_triggers.preview.current_event') }}</strong> <span>{{ current_trigger_id || $t('email_template_triggers.preview.unknown') }}</span></p>
          <p><strong style="display: inline-block; padding-bottom: 1em;">{{ $t('email_template_triggers.email_language') }}</strong><br />
            <b-form-select v-model="jsonEditorEmailPreviewLanguage" v-bind:value="jsonEditorEmailPreviewLanguage"
              :options="filter.languages_options">
            </b-form-select>
          </p>
          <p><strong>{{ $t('email_template_triggers.preview.payload_content') }}</strong></p>
          <b-button
            :class="jsonEditorVisible ? null : 'collapsed'"
            :aria-expanded="jsonEditorVisible ? 'true' : 'false'"
            aria-controls="collapse-4"
            @click="jsonEditorVisible = !jsonEditorVisible"
            variant="info"
          >
            {{ $t('email_template_triggers.preview.customize_payload') }}
          </b-button>
          <p />
          <b-collapse id="jsonLinedTextarea" v-model="jsonEditorVisible" accordion="json-lined-textarea" role="tabpanel">
            <lined-textarea 
              :disabled="false"
              :nowrap="true"
              :styles="{ height: '256px', width: '100%' }"
              v-model="jsonString"
            ></lined-textarea>
          </b-collapse>
          <!-- <b-form-textarea style="width: 100%; height: 128px;" v-model="jsonString" @change="onOverrideChangeJsonPayloadData"></b-form-textarea> -->
          <p />
          <tree-view :data="json || {}" :options="{maxDepth: 7, rootObjectKey: $t('email_template_triggers.preview.json_tree_root'), modifiable: true}" @change-data="onChangeJsonPayloadData"></tree-view>
        </div>
    </b-modal>
  </div>
</template>

<style>
  .email-template-triggers {
    padding: 20px;
  }
</style>

<style scoped>
</style>

<script>
import uuid from 'uuid';
import { getPayload } from './payloads';
import LinedTextarea from '../../../components/LinedTextarea.vue'

export default {
  name: 'EmailTemplateTriggersList',
  components: {
    LinedTextarea
  },
  data: function () {
    return {
      authUser: this.$auth.user().user_info.user,
      wsConnection: null,
      session: {
        lang: this.$session.get('lang') || 'en',
      },
      client_id: Number(this._.get(this.$store.getters.config, 'base.id', 0)),
      user_email: this.$auth.user().user_info.user.email,
      filter: {
        gms_service_id: null,
        languages_options: []
      },
      gms_services_id: [{ value: null, text: this.$t('common.all') }].concat(this.$const.GMS_SERVICES),
      json: null,
      jsonString: JSON.stringify({}),
      jsonEditorEmailPreviewLanguage: 'en',
      jsonEditorVisible: false,
      current_trigger_id: null,
      dataTable: {
        items: [],
        fields: [
          {
            name: 'trigger_id',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          // {
          //   name: 'template_id',
          //   filter: true,
          //   sort: true,
          //   render: (data, row) => {
          //     if (data == null) {
          //       return ''
          //     }
          //     return data
          //   }
          // },
          {
            name: 'template_name',
            filter: false,
            sort: false,
            render: (data, row) => {
              try {
                if (data == null) {
                  return ''
                }
                return data[this.session.lang]
              } catch (e) {
                return 'N/A'
              }
            }
          },
          {
            name: 'service',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'updated_by',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'updated_at',
            filter: true,
            sort: true,
            render: (data, row) => {
              const dateString = this.$moment(data).format('YYYY-MM-DD HH:mm:ss');
              if (data == null) {
                return ''
              }
              return dateString
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      }
    }
  },
  methods: {
    getLanguageList() {
      let config = this.$store.getters.config
      for (let i in config.main.language) {
        this.filter.languages_options[config.main.language[i]] = []
        this.filter.languages_options.push({
          text: this.$t('common.'+config.main.language[i]),
          value: config.main.language[i] == 'en' ? config.main.language[i] + '_' + config.base.id : config.main.language[i]
        })
      }
    },
    getTemplatesTriggersParams () {
      const vm = this;
      let _data = {
        client_uuid: String(localStorage.getItem('clientID')),
        client_id: this.client_id,
        page: vm.dataTable.currentPage,
        limit: vm.dataTable.perPage,
        sort_field: vm.dataTable.sort.field,
        sort_type: vm.dataTable.sort.type
      }
      if (vm.filter.gms_service_id) {
        _data.service = vm.filter.gms_service_id
      }
      let params = '';
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      params = params.slice(0, -1)
      return params
    },
    createItem () {
      this.$router.push({name: 'email_template_trigger_create', params: { uuid: 'create' }})
    },
    editItem (uuid) {
      this.$router.push({name: 'email_template_trigger_edit', params: { uuid }})
    },
    deleteItem (uuid, trigger_id) {
      const vm = this;
      const options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(`${vm.$t('email_template_triggers.delete_confirm').replace('{TRIGGER_NAME}', trigger_id)}`, options)
        .then(function () {
          vm.axios.notification.deleteEmailTemplateTrigger({ uuid, name: trigger_id }, function (response) {
            vm.$toastr.success(vm.$t('message.remove_successful'), vm.$t('message.success'), {})
            vm.refreshData()
          }, function () {
            vm.$toastr.error(vm.$t('message.delete_fail'), vm.$t('message.error'), {})
          }, { email: vm.authUser.email })
        })
    },
    canPreviewItem () {
      if (this.json) {
        return Object.keys(this.json).length > 0
      }
      return true
    },
    previewItem (item) {
      const vm = this
      // Prepare data
      const { trigger_id } = item
      vm.current_trigger_id = trigger_id
      vm.json = {
        ...getPayload(trigger_id),
      }
      vm.jsonString = JSON.stringify(vm.json, null, 2)
      // Set preview dialog default language item
      let previewDialogLanguage = this.filter.languages_options.find(
        item => item.value.toLowerCase().includes(
          this.$session.get('lang').toLowerCase()
        )
      )
      if (previewDialogLanguage) {
        this.jsonEditorEmailPreviewLanguage = previewDialogLanguage.value
      }
      // Show json editor modal
      vm.$refs.jsonEditorModal.show()
    },
    onChangeJsonPayloadData (data) {
      const vm = this
      vm.json = JSON.parse(JSON.stringify(data))
      vm.jsonString = JSON.stringify(vm.json, null,2)
    },
    // onOverrideChangeJsonPayloadData () {
    //   const vm = this
    //   try {
    //     vm.json = JSON.parse(vm.jsonString)
    //   } catch (e) {
    //     vm.$toastr.error(vm.$t('email_template_triggers.invalid_json_data'), vm.$t('message.error'), {})
    //   }
    // },
    executePreviewItem (item) {
      let jsonData = {}

      const vm = this
      const trigger_id = vm.current_trigger_id
      const preview_email_language = vm.jsonEditorEmailPreviewLanguage

      try {
        jsonData = JSON.parse(JSON.stringify(vm.json))
      } catch (e) {
        vm.$toastr.error(vm.$t('email_template_triggers.invalid_json_data'), vm.$t('message.error'), {})
        return
      }

      if (jsonData) {
        let isValid = true

        for (const key of Object.keys(jsonData)) {
          if (String(jsonData[key]).trim().length == 0) {
            isValid = false
          }
        }

        if (!isValid) {
          vm.$toastr.error(vm.$t('email_template_triggers.preview.invalid_input_json'), vm.$t('message.error'), {})
          return
        }

        const params = {
          event: trigger_id,
          client_id: vm.client_id,
          lang: preview_email_language,
          to: [
            vm.user_email
          ],
          data: jsonData,
        };

        if (params.event) {
          vm.axios.notification.previewEmailTemplateTrigger(params, function (response) {
            vm.$dialog.alert({
              title: vm.$t('common.preview'),
              body: vm.$t('email_template_triggers.email_sent_success'),
            })
          })
        } else {
          vm.$toastr.error(vm.$t('email_template_triggers.email_type_not_specified'), vm.$t('message.error'), {})
        }
      } else {
        vm.$toastr.error(vm.$t('email_template_triggers.unable_parse_json'), vm.$t('message.error'), {})
      }
    },
    updateSort (field) {
      const vm = this;
      for (let i in vm.dataTable.fields) {
        if (vm.dataTable.fields[i].name == field
        && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (vm.dataTable.sort.field != field) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (vm.dataTable.sort.type == 'asc') {
          vm.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      vm.refreshData()
    },
    refreshData () {
      const vm = this;
      this.axios.notification.getEmailTemplateTriggersList(
        vm.getTemplatesTriggersParams(),
        function(response) {
          vm.dataTable.items = response.data.data.items;
          vm.dataTable.total = response.data.data._metadata.total
        });
    },
  },
  created: function () {
    this.refreshData()
    this.getLanguageList()
  },
  watch: {
    'filter.gms_service_id': function (val) {
      const vm = this;
      vm.refreshData()
    },
    'jsonString': function (val) {
      const vm = this;
      try {
        vm.json = JSON.parse(val)
      } catch (e) {}
    }
  },
  computed: {},
}
</script>



// WEBPACK FOOTER //
// src/views/admin/email-template/TriggerList.vue